import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setactiveItem } from "store/cards";
import GradientBlock from "components/GradientBlock";
import useActiveItem from "hooks/useActiveItem";
import Loader from "components/Loader";
import usePageItems from "hooks/usePageItems";
import useFiltersData from "hooks/useFiltersData";
import Pagination from "components/Pagination";
import MainContentLeft from "components/main-components/MainContentLeft";
import BuyPacksEmpty from "components/placeholder-blocks/BuyPacksEmpty";
import CardPacksEmpty from "components/placeholder-blocks/CardPacksEmpty";
import CardsCollection from "components/cards-collection/CardsCollection";
import useEffectOnce from "hooks/useEffectOnce";
import PageLoader from "components/page-components/PageLoader";
import MainSortInputSearch from "components/main-components/MainSortInputSearch";
import useProfile from "hooks/useProfile";
import Cookies from "js-cookie";
import MainSortTutorLink from "components/main-components/MainSortTutorLink";

const BuyPacks = () => {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const [isFiltersLoading, setIsFiltersLoading] = useState(false);
  const [isItemsLoading, setIsItemsLoading] = useState(false);
  const [offsetCount, setOffsetCount] = useState(0);
  const { isActiveItem } = useActiveItem();
  const {isLogged} = useProfile();
  const token = Cookies.get('token');
  const dispatch = useDispatch();
  const {search} = useLocation();

  const getOpenedClass = () => {
    if (
      (filters !== null && Array.isArray(items) && items.length > 0) ||
      isActiveItem
    ) {
      return "opened";
    } else if (!filters && Array.isArray(items) && items.length < 1) {
      return "";
    }
  };

  useFiltersData(setFilters, setIsFiltersLoading);
  usePageItems(
    setItems,
    setPaginationData,
    offsetCount,
    setIsItemsLoading,
    null
  );

  useEffectOnce(() => {
    setOffsetCount(0);
  });

  useEffect(() => {
    const searchQuery = new URLSearchParams(search);
    const searchQueryId = searchQuery.get('search_id')

    if(searchQuery && items.length) {
      const allItems = items.map((item) => item.series).flat();
      const searchedItem = allItems.find((item) => item.id === Number(searchQueryId))

      dispatch(setactiveItem(searchedItem));
    }

  }, [items])

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  if (!token && !isLogged) {
    return (
      <>
        <GradientBlock>
          <div className="gradient-block__search">
            <MainSortInputSearch placeholder="Collection name" />
          </div>
        </GradientBlock>
        <main className="main-content">
          <div className="main-content__left"></div>
          <div className="main-content__right">
            <BuyPacksEmpty />
          </div>
        </main>
      </>
    );
  }

  return (
    <>
      <GradientBlock>
        <div className="gradient-block__search">
          <MainSortInputSearch placeholder="Collection name" />
          <MainSortTutorLink />
        </div>
      </GradientBlock>
      <main className="main-content">
        <MainContentLeft
          getOpenedClass={getOpenedClass}
          filters={filters}
          setOffsetCount={setOffsetCount}
        />
        <div className="main-content__right">
          {isItemsLoading && !items.length ? (
            <Loader />
          ) : items.length ? (
            items.map((collection) => (
              <CardsCollection key={collection.id} collection={collection} />
            ))
          ) : (
            <CardPacksEmpty />
          )}
          <Pagination
            offsetCount={offsetCount}
            setOffsetCount={setOffsetCount}
            paginationData={paginationData}
          />
        </div>
      </main>
    </>
  );
};

export default BuyPacks;
